import styled, { createGlobalStyle } from "styled-components";

export const StyledImage = styled.img`
  marging: 0 auto;
`;

export const GlobalStyle = createGlobalStyle`
    body{
        height: 100%;
        margin: 0;
        padding: 0;
      }
    `;

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  max-height: 100vh;
  flex-direction: column;
  overflow: hidden;
`;

export const HomeMain = styled.main`
  flex: 1;
  display: flex;
  height: calc(100% - 6vh);
`;

export const HomeMainContent = styled.div`
  max-height: 100%;
  overflow: auto;
  width: 100%;
`;
